import { render, staticRenderFns } from "./OverviewASAP.template.vue?vue&type=template&id=624a65a8&scoped=true&"
var script = {}


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "624a65a8",
  null
  
)

export default component.exports